/**
 * Placeholder Profile Activations dataset — mirrors the shape the backend
 * endpoint returns (GET /admin/analytics/stat/getProfileActivations). Used as a
 * fallback so the tab renders the full design even when the live source is
 * unavailable, exactly like the mockup ships with baked-in data.
 */
const mk = (lab, sub, m, f, tip, cur = false) => ({ lab, sub, m, f, tip, cur });

const SAMPLE_DB = {
  daily: [
    mk('31', 'May', 50, 32, '31 May 2026'), mk('1', 'Jun', 48, 26, '1 Jun 2026'), mk('2', '', 35, 21, '2 Jun 2026'),
    mk('3', '', 33, 19, '3 Jun 2026'), mk('4', '', 35, 21, '4 Jun 2026'), mk('5', '', 38, 26, '5 Jun 2026'),
    mk('6', '', 44, 31, '6 Jun 2026'), mk('7', '', 52, 28, '7 Jun 2026'), mk('8', '', 44, 30, '8 Jun 2026'),
    mk('9', '', 37, 25, '9 Jun 2026'), mk('10', '', 39, 24, '10 Jun 2026'), mk('11', '', 40, 27, '11 Jun 2026'),
    mk('12', '', 43, 27, '12 Jun 2026'), mk('13', '', 44, 29, '13 Jun 2026'), mk('14', '', 47, 31, '14 Jun 2026'),
    mk('15', '', 46, 27, '15 Jun 2026'), mk('16', '', 38, 25, '16 Jun 2026'), mk('17', '', 40, 25, '17 Jun 2026'),
    mk('18', '', 38, 23, '18 Jun 2026'), mk('19', '', 46, 25, '19 Jun 2026'), mk('20', '', 40, 23, '20 Jun 2026'),
    mk('21', '', 51, 28, '21 Jun 2026'), mk('22', '', 44, 26, '22 Jun 2026'), mk('23', '', 42, 24, '23 Jun 2026'),
    mk('24', '', 34, 21, '24 Jun 2026'), mk('25', '', 42, 25, '25 Jun 2026'), mk('26', '', 40, 23, '26 Jun 2026'),
    mk('27', '', 43, 29, '27 Jun 2026'), mk('28', '', 43, 29, '28 Jun 2026'), mk('29', '', 46, 27, '29 Jun 2026'),
    mk('30', '', 36, 23, '30 Jun 2026'), mk('1', 'Jul', 41, 25, '1 Jul 2026'), mk('2', '', 41, 25, '2 Jul 2026'),
    mk('3', '', 40, 26, '3 Jul 2026'), mk('4', '', 48, 27, '4 Jul 2026'), mk('5', '', 48, 29, '5 Jul 2026'),
    mk('6', '', 47, 28, '6 Jul 2026'), mk('7', '', 39, 27, '7 Jul 2026'), mk('8', '', 44, 24, '8 Jul 2026'),
    mk('9', '', 41, 24, '9 Jul 2026'), mk('10', '', 43, 24, '10 Jul 2026'), mk('11', '', 45, 26, '11 Jul 2026'),
    mk('12', '', 51, 34, '12 Jul 2026'), mk('13', '', 44, 30, '13 Jul 2026'), mk('14', 'Today', 26, 17, '14 Jul 2026', true),
  ],
  weekly: [
    mk('26 Apr', '', 253, 153, 'week 20 Apr 2026 – 26 Apr 2026'), mk('3 May', '', 276, 178, 'week 27 Apr 2026 – 3 May 2026'),
    mk('10 May', '', 290, 189, 'week 4 May 2026 – 10 May 2026'), mk('17 May', '', 301, 198, 'week 11 May 2026 – 17 May 2026'),
    mk('24 May', '', 303, 181, 'week 18 May 2026 – 24 May 2026'), mk('31 May', '', 295, 190, 'week 25 May 2026 – 31 May 2026'),
    mk('7 Jun', '', 285, 172, 'week 1 Jun 2026 – 7 Jun 2026'), mk('14 Jun', '', 294, 193, 'week 8 Jun 2026 – 14 Jun 2026'),
    mk('21 Jun', '', 299, 176, 'week 15 Jun 2026 – 21 Jun 2026'), mk('28 Jun', '', 288, 177, 'week 22 Jun 2026 – 28 Jun 2026'),
    mk('5 Jul', '', 300, 182, 'week 29 Jun 2026 – 5 Jul 2026'), mk('12 Jul', '', 310, 187, 'week 6 Jul 2026 – 12 Jul 2026'),
    mk('This wk', 'to date', 70, 47, 'week starting 13 Jul 2026 (2 days so far)', true),
  ],
  monthly: [
    mk('Jul', '2025', 978, 602, 'Jul 2025'), mk('Aug', '', 897, 565, 'Aug 2025'), mk('Sep', '', 1070, 671, 'Sep 2025'),
    mk('Oct', '', 1318, 817, 'Oct 2025'), mk('Nov', '', 1210, 751, 'Nov 2025'), mk('Dec', '', 1094, 679, 'Dec 2025'),
    mk('Jan', '2026', 1651, 1054, 'Jan 2026'), mk('Feb', '', 1377, 882, 'Feb 2026'), mk('Mar', '', 1308, 804, 'Mar 2026'),
    mk('Apr', '', 1102, 680, 'Apr 2026'), mk('May', '', 1318, 844, 'May 2026'), mk('Jun', '', 1248, 768, 'Jun 2026'),
    mk('Jul', '2026', 598, 366, 'Jul 2026 (month to date)', true),
  ],
  kpi: { today: { m: 26, f: 17 }, l7: 473, p7: 491, l30: 2036, p30: 2062, w30m: 1267, w30f: 769 },
};

/**
 * Cohort + attrition placeholders, generated rather than pasted so this file stays
 * readable (the mockup ships ~56KB of baked JSON for the same thing). Shape matches the
 * endpoint exactly: coh[basis][gender][i], 60 daily cohorts ending today.
 *
 * Deterministic — no Math.random — so the fallback render is stable between reloads and
 * the verify harness can diff it against the mockup's own renderer.
 */
const COHORT_DAYS = 60;
const MS_DAY = 86400000;
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// Small deterministic hash -> a stable pseudo-random in [0,1) for a given key.
//
// FNV-1a alone is NOT enough here. Its avalanche in the high bits is poor, so keys that
// share a prefix and differ only in their last character or two (exactly our pattern —
// `latem07`, `latem08`, …) barely move the top bits. Taking `h >>> 8` off raw FNV made a
// whole key family land in a narrow band (measured: max 0.60 across 53 draws that should
// have spanned 0..1), which silently flattened the generated jitter. The murmur3 fmix32
// finalizer below scrambles the bits properly before we slice them.
const rnd = (n) => {
  let h = 2166136261;
  const s = `favor-pa|${n}`;
  for (let i = 0; i < s.length; i += 1) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
  h ^= h >>> 16; h = Math.imul(h, 2246822507) >>> 0;
  h ^= h >>> 13; h = Math.imul(h, 3266489909) >>> 0;
  h ^= h >>> 16;
  return (h >>> 8) / 16777216;
};

// "Active" here = the APPROVED status (profile complete, visible in search), so the fall
// is slow: it takes a hide, a suspension, a self-deactivation or a profile regressing to
// inactive. Live data says ~34% of an activation cohort is still approved weeks on.
const curve = (k, g) => {
  if (k === 0) return 1;
  const floor = g === 'f' ? 0.40 : 0.30;
  return floor + (1 - floor) * Math.exp(-k / 14);
};

// The endpoint returns EXACT cells once the status log covers the day and UPPER BOUNDS
// before it (reconstructed from the only datable exits: deletions, deactivations,
// shadow-hides). It never returns null. The placeholder has to have the same shape or the
// offline fallback would render differently from the live tab. Pretend recording began 3
// days ago, so the last few cells are "exact" and the rest are bounds.
const RECORDED_FROM = COHORT_DAYS - 3;

const buildCohorts = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const out = { act: { o: [], m: [], f: [] }, sign: { o: [], m: [], f: [] } };

  for (let i = 0; i < COHORT_DAYS; i += 1) {
    const d = new Date(today.getTime() - (COHORT_DAYS - 1 - i) * MS_DAY);
    const lab = `${d.getDate()} ${MONTHS[d.getMonth()]}`;
    const elapsed = COHORT_DAYS - 1 - i;
    // Activation cohort: grows over the window, men ~60/40.
    const sizeM = 6 + Math.round(rnd(`m${i}`) * 8 + i * 0.30);
    const sizeF = 4 + Math.round(rnd(`f${i}`) * 5 + i * 0.18);

    // Day 0 is definitional (they activated that day). Later days are null unless the
    // status log reaches them — exactly what the endpoint returns.
    // Before the log, only the datable exits (deletions etc.) can drop out, so the bound
    // decays barely at all — exactly the flat-then-cliff shape live data shows.
    const mk = (size, g, seed) => {
      const act = [];
      for (let k = 0; k <= elapsed; k += 1) {
        if (k === 0) act.push(size);
        else if (i + k < RECORDED_FROM) act.push(Math.max(1, size - Math.round(size * 0.06 * Math.min(k, 3))));
        else act.push(Math.round(size * curve(k, g) * (0.92 + rnd(`${seed}${k}`) * 0.16)));
      }
      return act;
    };
    const aM = mk(sizeM, 'm', `am${i}`);
    const aF = mk(sizeF, 'f', `af${i}`);
    const lastOf = (a) => a[a.length - 1];
    out.act.m.push({ iso: iso(d), lab, size: sizeM, act: aM, activeNow: lastOf(aM), dateless: Math.max(0, sizeM - lastOf(aM) - 1) });
    out.act.f.push({ iso: iso(d), lab, size: sizeF, act: aF, activeNow: lastOf(aF), dateless: Math.max(0, sizeF - lastOf(aF) - 1) });
    const sumCells = (a, b) => a.map((v, k) => (v === null || b[k] === null ? null : v + b[k]));
    const aO = sumCells(aM, aF);
    out.act.o.push({ iso: iso(d), lab, size: sizeM + sizeF, act: aO, activeNow: lastOf(aO), dateless: Math.max(0, sizeM + sizeF - lastOf(aO) - 1) });

    // Signup cohort: ~5x the activations, most converting on day 0 and a thin late tail.
    const mkSign = (size, g, seed) => {
      const S = size * 5 + Math.round(rnd(`s${seed}`) * 20);
      const na = [];
      const act = [];
      for (let k = 0; k <= elapsed; k += 1) {
        na.push(k === 0 ? size : Math.max(0, Math.round(size * 0.18 * Math.exp(-k / 1.6))));
      }
      let converted = 0;
      for (let k = 0; k <= elapsed; k += 1) {
        converted += na[k];
        if (k === 0) act.push(na[0]);
        else if (i + k < RECORDED_FROM) act.push(Math.max(1, converted - Math.round(converted * 0.06 * Math.min(k, 3))));
        else act.push(Math.round(converted * curve(k, g) * (0.92 + rnd(`${seed}a${k}`) * 0.16)));
      }
      return { S, na, act };
    };
    const sM = mkSign(sizeM, 'm', `m${i}`);
    const sF = mkSign(sizeF, 'f', `f${i}`);
    out.sign.m.push({ iso: iso(d), lab, S: sM.S, na: sM.na, act: sM.act, activeNow: lastOf(sM.act), dateless: 0 });
    out.sign.f.push({ iso: iso(d), lab, S: sF.S, na: sF.na, act: sF.act, activeNow: lastOf(sF.act), dateless: 0 });
    out.sign.o.push({
      iso: iso(d),
      lab,
      S: sM.S + sF.S,
      na: sM.na.map((v, k) => v + sF.na[k]),
      act: sM.act.map((v, k) => v + sF.act[k]),
      activeNow: lastOf(sM.act) + lastOf(sF.act),
      dateless: 0,
    });
  }
  return out;
};

// Attrition = the average share of each activation cohort still active on day k. Derived
// from coh.act so the placeholder curves and the placeholder table can never disagree.
const buildAttr = (coh) => {
  const attr = {};
  ['o', 'm', 'f'].forEach((g) => {
    attr[g] = [];
    for (let k = 0; k < COHORT_DAYS; k += 1) {
      const ps = [];
      coh.act[g].forEach((c) => { if (k < c.act.length && c.act[k] !== null && c.act[0]) ps.push((100 * c.act[k]) / c.act[0]); });
      attr[g].push(ps.length ? Number((ps.reduce((a, b) => a + b, 0) / ps.length).toFixed(1)) : 0);
    }
  });
  return attr;
};

SAMPLE_DB.coh = buildCohorts();
SAMPLE_DB.attr = buildAttr(SAMPLE_DB.coh);

export default SAMPLE_DB;
